import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import BelpimpalgaonBhushan from "./pages/BelpimpalgaonBhushan";
import Contact from "./pages/Contact";   // ✅ CONTACT IMPORT
import Development from "./pages/Development";
import Notice from "./pages/Notice";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ReligiousPlaces from "./pages/ReligiousPlaces";
import UserLogin from "./pages/UserLogin";
import UserDashboard from "./pages/UserDashboard";


function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/bhushan" element={<BelpimpalgaonBhushan />} />
        <Route path="/contact" element={<Contact />} /> {/* ✅ FIXED */}
        <Route path="/development" element={<Development />} />
        <Route path="/notice" element={<Notice />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/religious-places" element={<ReligiousPlaces />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
